import { Flex, FlexProps, InputProps } from "@chakra-ui/react";
import React, { useMemo } from "react";
import type { Props as SelectProps } from "react-select";

import { SelectDateRange, useTheme } from "../../../components";
import type {
  DateRangeOption,
  SelectDateRangeState,
} from "../../../components/SelectDateRange/SelectDateRange";
import { useAnalyticsSelectTheme } from "./useAnalyticsSelectTheme";

type AnalyticsDateSelectProps = {
  disabled?: boolean;
  state: SelectDateRangeState;
  onSelect: (newValue: SelectDateRangeState | undefined) => void;
  minDate?: Date;
  direction?: "row" | "column";
  dateInputStyleProps?: InputProps;
  rangeStyleProps?: FlexProps;
  customOptionLabel?: string;
  datePickerWrapperClassName?: string;
  selectComponentOverrides?: SelectProps<DateRangeOption, false>["components"];
  selectStyleOverrides?: SelectProps<DateRangeOption, false>["styles"];
};

const AnalyticsDateSelect: React.FC<AnalyticsDateSelectProps> = ({
  disabled,
  state,
  onSelect,
  minDate,
  direction = "row",
  dateInputStyleProps = {},
  rangeStyleProps,
  customOptionLabel,
  datePickerWrapperClassName,
  selectComponentOverrides,
  selectStyleOverrides,
}) => {
  const { colors } = useTheme();
  const [selectTheme, selectStyles] = useAnalyticsSelectTheme();
  const mergedSelectStyles = useMemo(
    () => ({ ...selectStyles, ...selectStyleOverrides }),
    [selectStyles, selectStyleOverrides]
  );

  return (
    <Flex minW="148px" opacity={disabled ? 0.6 : 1}>
      <SelectDateRange
        disabled={disabled}
        state={state}
        onSelect={onSelect}
        minDate={minDate}
        includeLabel={false}
        selectStyles={mergedSelectStyles}
        selectTheme={selectTheme}
        selectComponentOverrides={selectComponentOverrides}
        direction={direction}
        customOptionLabel={customOptionLabel}
        datePickerWrapperClassName={datePickerWrapperClassName}
        rangeStyleProps={{ wrap: "nowrap", ...rangeStyleProps }}
        dateInputStyleProps={{
          fontSize: "14px",
          color: colors.gray[900],
          borderColor: colors.gray[100],
          ...dateInputStyleProps,
        }}
        gaCategory="analytics"
      />
    </Flex>
  );
};

export default AnalyticsDateSelect;
